module.exports = __webpack_public_path__ + "img/bg_left_top.9f26bad4.png";